import { ArrowBackOutlined, ArrowForwardOutlined, CopyAllOutlined, DeleteOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

export function SolutionCard({solution}) {
    const { t, i18n } = useTranslation();

    return <div className="solution-card" style={{fontFamily: 'Open Sans, sans-serif'}}>
        <div className="card-header">
            <div className="app-icon">
                <img src={solution.getLogo()} alt={solution.getName()}/>
            </div>
            <h3>{solution.getName()}</h3>
            <div style={{display: 'flex', gap: '5px', flexWrap: 'wrap', }}>
                {solution.getCategories().map(cat => <span key={cat} className="category-label">{t(`solutions.categories.${cat}`)}</span>)}
            </div>
        </div>
        <div className="card-body">
            <p>{solution.getShortDescriptionByLang(i18n.resolvedLanguage??'en')}</p>
            <div className="platforms">
                {solution.getPlatforms().map((pla, index) => <span key={index} className="platform"><i className="fab"></i> {pla}</span>)}
            </div>
        </div>
        <div className="card-footer">
            <a href={`/solutions/${solution.getId()}`} className="details-btn">{t('actions.edit')}</a>
        </div>
    </div>;
}

export function SolutionPricingCard({ price, canEdit=true, language='en', onDuplicate=(e)=>{}, onDelete=(e)=>{}, onClick=(price)=>{}, onMoveRight=(e)=>{}, onMoveLeft=(e)=>{}, moveRight=true, moveLeft=false }) {
    const { t } = useTranslation();

    return <div className={`solution-pricing-card ${price.getActive() ? 'solution-featured' : ''} ${canEdit?'clickable':''}`} style={{position: 'relative'}} onClick={() => {onClick(price)}}>
        {price.getActive() ? <div className="solution-popular-badge">{t('solutions.page.mostPopular')}</div> : null}
        <h3>{price.getTitleByLang(language)}</h3>
        <div className={`solution-price ${price.getSecondary() !== undefined ? 'has-secondary' : ''}`}>{price.getPrimary().getValueByCurrency('eur')}<span>/{price.getPrimary().getPeriodByLang(language)}</span></div>
        {price.getSecondary() !== undefined
            ? <div className="solution-price-secondary">{price.getSecondary().getValueByCurrency('eur')}<span>/{price.getSecondary().getPeriodByLang(language)}</span></div>
            : null
        }
        <ul className="solution-features-list">
            {price.getFeatures().map((feature, index) => <li key={index}>{price.getFeaturesByLang(language, index)}</li>)}
        </ul>
        {canEdit
            ? <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
            }}>
                <Tooltip title={t('solutions.page.pricing.actions.duplicatePrice')}><IconButton onClick={onDuplicate}><CopyAllOutlined/></IconButton></Tooltip>
                <Tooltip title={t('solutions.page.pricing.actions.deletePrice')}><IconButton onClick={onDelete}><DeleteOutlined/></IconButton></Tooltip>
                <Tooltip title={t('actions.moveLeft')}><IconButton onClick={moveLeft ? onMoveLeft : null} disabled={!moveLeft}><ArrowBackOutlined/></IconButton></Tooltip>
                <Tooltip title={t('actions.moveRight')}><IconButton onClick={ moveRight ? onMoveRight : null} disabled={!moveRight}><ArrowForwardOutlined/></IconButton></Tooltip>
            </div> : null
        }
    </div>;
}